<template>
  <div>
    <div style="margin:5px;" :class="parentClass">
      <img id="image" :src="cropImageUrl">
    </div>
    <div v-if="aspectRatio && aspectRatio['desktop']" style="display:flex;justify-content:center;">
      <button @click="cropMode = 'mobile'" :class="crops.mobile.done ? 'done' : ''">MOBILE</button>
      <button @click="cropMode = 'desktop'" :class="crops.desktop.done ? 'done' : ''">DESKTOP</button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";

export default {
  name: "modal",
  props: ["image", "aspectRatio"],
  components: {
      
  },
  data: function() {
    return {
        cropImageUrl: "",
        cropMode: 'mobile',
        cropper:null,
        parentClass: "",
        crops: {
          mobile: {
            done: false,
            data: false,
            cropBox: false
          },
          desktop: {
            done: false,
            data: false,
            cropBox: false
          }
        },
    };
  },
  watch: {
    cropMode: function(val, oldVal) {
      if(this.cropMode && this.aspectRatio &&  this.aspectRatio[this.cropMode] && this.cropper) {
        console.log(oldVal);
        this.cropper.crop();
        this.cropper.getCroppedCanvas().toBlob((blob) => {
          this.crops[oldVal].data = blob;
          this.crops[oldVal].done = true;
          this.crops[oldVal].cropBox = this.cropper.getCropBoxData();
          if(this.aspectRatio[this.cropMode] && this.aspectRatio[this.cropMode] != "any")
            this.cropper.setAspectRatio(this.aspectRatio[this.cropMode]);
          if(this.crops[val].cropBox) this.cropper.setCropBoxData(this.crops[val].cropBox);
        }, "image/jpeg");
      }
    }
  },
    methods: {
      openImageFromUrl: function(url) {
        if(!url) return;
        if(this.cropper) {
          this.cropper.destroy();
        }
        if($("#image")) $("#image").off('load');
        var aspect = false;
        this.parentClass = '';
        if(this.cropMode && this.aspectRatio &&  this.aspectRatio[this.cropMode] && this.aspectRatio[this.cropMode] != "any") {
          aspect = this.aspectRatio[this.cropMode];
          if(this.aspectRatio.circle) this.parentClass = 'circle-crop';
        }
        console.log(this.cropMode, this.aspectRatio, aspect);
        Vue.nextTick(() => {
          this.cropImageUrl = url;
          Vue.nextTick(() => {
            this.cropper = new Cropper(document.getElementById("image"), {
                zoomable:false,
                viewMode: 2,
                autoCropArea: 100,
                aspectRatio: aspect,
                crop(event) {

                },
            });
          });
        });
      },
      openImageFromData: function(data) {
        let TYPED_ARRAY = new Uint8Array(data);
        const STRING_CHAR = TYPED_ARRAY.reduce((data, byte)=> {
          return data + String.fromCharCode(byte);
        }, '');
        let base64String = btoa(STRING_CHAR);
        this.openImageFromUrl('data:image/jpg;base64, ' + base64String);
      },
      getCropData: function() {
        this.cropper.getCroppedCanvas().toBlob((blob) => {
          this.crops[this.cropMode].data = blob;
          this.crops[this.cropMode].done = true;
          this.crops[this.cropMode].cropBox = this.cropper.getCropBoxData();
          this.$emit("crop-data", this.crops);
        }, "image/jpeg");
      }
    }
};
</script>

<style scoped>
#image {
  max-width: 100%; /* This rule is very important, please do not ignore this! */
  max-height:calc(95vh - 175px);
}

button.done {
  background-color: green;
}
button {
  margin-left:5px;
  margin-right: 5px;
}
</style>
<style>
.circle-crop .cropper-crop-box, .circle-crop .cropper-view-box {
border-radius: 50%;
}

.circle-crop .cropper-view-box {
box-shadow: 0 0 0 1px #39f;
outline: 0;
}
.circle-crop .cropper-face {
  background-color:inherit !important;
}

.circle-crop .cropper-dashed, .circle-crop .cropper-point.point-se, .circle-crop .cropper-point.point-sw, .circle-crop .cropper-point.point-nw,   .circle-crop .cropper-point.point-ne, .circle-crop .cropper-line {
  display:none !important;
}

.circle-crop .cropper-view-box {
  outline:inherit !important;
}
</style>


// WEBPACK FOOTER //
// imageCrop.vue?6b22d9f0